// Per-user conveniences kept in this browser (localStorage). Storage can be missing,
// full or blocked (private windows, cleared site data), so every access is guarded
// and a failure only means the convenience is not remembered.

/** A stable key for the signed-in user; 'anonymous' until one is known. */
export const userKeyOf = (user) => {
  const id = user?.id ?? user?.pk ?? user?.email ?? user?.username
  return id === undefined || id === null || id === '' ? 'anonymous' : String(id)
}

export const readJson = (key) => {
  try {
    const raw = window.localStorage.getItem(key)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export const writeJson = (key, value) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value))
    return true
  } catch (e) {
    return false
  }
}

export const removeKey = (key) => {
  try {
    window.localStorage.removeItem(key)
  } catch (e) {
    // Nothing to remove.
  }
}
